// Example data for demo mode
export const EXAMPLE_DATA = {
  company: {
    name: "Sentinel Compliance",
    domain: "sentinelcompliance.io",
    oneliner: "AI-powered financial crime detection and compliance automation for banks, crypto exchanges, and payment providers.",
    targetMarket: `We sell AI-powered AML screening and transaction monitoring solutions to compliance teams at financial institutions.

Our primary customers are:
- Mid-size retail and commercial banks (£5B-£100B AUM)
- Cryptocurrency exchanges and digital asset platforms
- Private banks and wealth managers
- Payment service providers and fintechs

Key buyers are Heads of Compliance, MLROs, AML Directors, and Heads of Financial Crime. Companies typically have 500-5000 employees and are based in UK/EMEA.`,
    problemsSolved: `1. Manual AML screening is slow and creates backlogs - our AI processes alerts 10x faster
2. False positive rates of 95%+ waste analyst time - we reduce this to under 40%
3. Regulatory requirements keep changing (6AMLD, Travel Rule) - we auto-update rules
4. Crypto transaction monitoring lacks traditional banking context - we bridge both worlds
5. Audit trails are fragmented across systems - we provide unified compliance dashboards`,
    businessStage: "scaling",
    messagingMaturity: "some_working",
    existingMessaging: "We help compliance teams catch more financial crime with less manual work. Our AI reduces false positives by 60% and cuts screening time in half.",
    bestCustomers: "Our best customers are MLROs at mid-size banks who are drowning in alerts and facing regulatory pressure. They've usually just failed an audit or had a near-miss with a sanctions breach. They value speed of implementation and proven results with similar institutions.",
    outreachGoal: "generate_meetings",
    successCriteria: "Book 10-15 qualified discovery calls with MLROs or Heads of Compliance at target institutions within 90 days. Aim for 30% conversion from meeting to pilot discussion."
  },

  personas: [
    {
      id: "example-1",
      name: "The Overwhelmed MLRO",
      headline: "Money Laundering Reporting Officer | Director/Head",
      status: "approved",
      pains: [
        "Alert volumes have tripled but headcount is frozen",
        "Board is asking for metrics they can't easily produce",
        "Fear of personal liability if something slips through"
      ],
      signals: {
        job_titles: ["Money Laundering Reporting Officer", "MLRO", "Head of Financial Crime"],
        industries: ["Banking & Financial Services"],
        geographies: ["UK", "EMEA"],
        company_traits: ["500-2000 employees"],
        buying_signals: ["Recent FCA review", "Compliance investment"]
      },
      metadata: {
        outbound_hooks: [
          "What if you could clear your alert backlog in weeks, not months?",
          "Other MLROs tell us they sleep better knowing AI catches what humans miss"
        ],
        objections: ["We've been burned by AI vendors who overpromised"],
        suggested_channels: ["LinkedIn", "Email"],
        confidence: "high"
      }
    }
  ]
}
